
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-c-22-u-9-h-vzfj-wi-8-euck-swq-2-g-y.json") })
        }
      }, "path---projects-c-22-u-9-h-vzfj-wi-8-euck-swq-2-g-y");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-c-22-u-9-h-vzfj-wi-8-euck-swq-2-g-y!./.cache/json/projects-c-22-u-9-h-vzfj-wi-8-euck-swq-2-g-y.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-c-22-u-9-h-vzfj-wi-8-euck-swq-2-g-y!./.cache/json/projects-c-22-u-9-h-vzfj-wi-8-euck-swq-2-g-y.json
// module chunks = 15178676390636814000